import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import getDateRangeAddress from "./DateRangeAddress";
import getPersonMinDetail from "./PersonMinDetail";

class SubjectDetail extends Component {
  componentDidMount() {}

  render() {
    const neighborPersons = [];
    if (this.props.node !== undefined && this.props.node !== null) {
      const addresses = _.get(this.props.node, "addresses[0].address");
      if (addresses) {
        _.forEach(addresses, (address, addIndex) => {
          const subjectDateFrom = _.get(address, "dateFrom[0]._", "");
          const subjectDateTo = _.get(address, "dateTo[0]._", "");
          const persons = _.get(address, "neighbours[0].person");
          let subjectNeighborRows = [];
          let subjectAdded = false;
          if (persons) {
            let neighborAddress = "";
            _.forEach(persons, (person, index) => {
              const personAddress = person.address[0];
              const newIndex = `${addIndex}_${index}`;
              const currentNeighborAddress = `${_.get(
                personAddress,
                "houseNumber[0]._",
                ""
              )} ${_.get(personAddress, "streetName[0]._", "")} ${_.get(
                personAddress,
                "streetSuffix[0]._",
                ""
              )}, ${_.get(personAddress, "city[0]._", "")}, ${_.get(
                personAddress,
                "state[0]._",
                ""
              )} ${_.get(personAddress, "zip[0]._", "")}`;
              if (neighborAddress !== currentNeighborAddress) {
                const neighborDateFrom = _.get(
                  personAddress,
                  "dateFrom[0]._",
                  ""
                );
                const neighborDateTo = _.get(personAddress, "dateTo[0]._", "");
                if (subjectNeighborRows.length > 0) {
                  neighborPersons.push(
                    <Table.Row key={`row_sub_neigh_${newIndex}`}>
                      <Table.Cell colSpan={100}>
                        <Table stackable key={`tbl_sub_neigh_${newIndex}`}>
                          <Table.Body>{subjectNeighborRows}</Table.Body>
                        </Table>
                      </Table.Cell>
                    </Table.Row>
                  );
                }
                neighborAddress = currentNeighborAddress;
                subjectNeighborRows = [];
                if (!subjectAdded) {
                  neighborPersons.push(
                    getDateRangeAddress(
                      "Subject At",
                      subjectDateFrom,
                      subjectDateTo,
                      address,
                      `sub_${this.props.index}_${addIndex}`,
                      this.props
                    )
                  );
                  subjectAdded = true;
                }

                subjectNeighborRows.push(
                  getDateRangeAddress(
                    "Neigbors At",
                    neighborDateFrom,
                    neighborDateTo,
                    personAddress,
                    newIndex,
                    this.props
                  )
                );
              }
              if (person) {
                subjectNeighborRows.push(
                  getPersonMinDetail(person, index, this.props, newIndex)
                );
              }
            });
            if (subjectNeighborRows.length > 0) {
              neighborPersons.push(
                <Table.Row key={`row_sub_neigh_outer_${addIndex}`}>
                  <Table.Cell colSpan={100}>
                    <Table stackable key={`tbl_sub_neigh_${addIndex}`}>
                      <Table.Body>{subjectNeighborRows}</Table.Body>
                    </Table>
                  </Table.Cell>
                </Table.Row>
              );
            }
          }
        });
      }
    }
    return neighborPersons.length > 0 ? (
      <Table.Row key={`Subject_Detail_Row_${this.props.index}`}>
        <Table.Cell colSpan={100}>
          <Table
            stackable
            key={`Subject_Detail_Header_Name_${this.props.index}`}
          >
            <Table.Body>{neighborPersons}</Table.Body>
          </Table>
        </Table.Cell>
      </Table.Row>
    ) : null;
  }
}

export default SubjectDetail;



// WEBPACK FOOTER //
// ./src/components/reports/SubjectDetail.js